import { render, staticRenderFns } from "./CopyDialog.vue?vue&type=template&id=289c51e0&scoped=true&"
import script from "./CopyDialog.vue?vue&type=script&lang=js&"
export * from "./CopyDialog.vue?vue&type=script&lang=js&"
import style0 from "./CopyDialog.vue?vue&type=style&index=0&id=289c51e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289c51e0",
  null
  
)

export default component.exports